export default "__VITE_ASSET__13fc84fa__"